import { initialState } from "./initialState";
import { errorMessage } from "../../constants/responseMessages";
import ApplicationConfigsService from "../../services/applicationConfigsService";
import {
  ADD_DRUG_TYPE,
  API_STATUS_MASTER,
  SET_ADMIN_APPROVAL_CONFIG,
  SET_DRUG_TYPES,
  UPDATE_DRUG_TYPE_APPROVAL,
} from "./types";

const service = new ApplicationConfigsService();

export const clearApiStatus = () => (dispatch) => {
  dispatch({
    type: API_STATUS_MASTER,
    payload: {
      ...initialState.apiStatus,
      loader: false,
      message: "",
      apiSuccess: false,
      apiError: false,
    },
  });
};

export const fetchAdminApprovalConfig = () => (dispatch) => {
  dispatch({
    type: API_STATUS_MASTER,
    payload: { ...initialState.apiStatus, loader: true },
  });

  service
    .getAdminApprovalConfig()
    .then((res) => {
      dispatch({
        type: SET_ADMIN_APPROVAL_CONFIG,
        payload: res.data.data,
      });

      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiSuccess: true,
        },
      });
    })
    .catch((error) => {
      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiError: true,
          message: errorMessage(error),
        },
      });
    });
};

export const fetchDrugTypes = () => (dispatch) => {
  dispatch({
    type: API_STATUS_MASTER,
    payload: {
      ...initialState.apiStatus,
      loader: true,
      operation: "fetch",
    },
  });

  service
    .getDrugTypes()
    .then((res) => {
      dispatch({
        type: SET_DRUG_TYPES,
        payload: res.data.data,
      });

      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiSuccess: true,
          operation: "fetch",
        },
      });
    })
    .catch((error) => {
      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiError: true,
          message: errorMessage(error),
          operation: "fetch",
        },
      });
    });
};

export const createDrugType = (data) => (dispatch) => {
  dispatch({
    type: API_STATUS_MASTER,
    payload: {
      ...initialState.apiStatus,
      loader: true,
      operation: "create",
    },
  });

  service
    .createDrugType(data)
    .then(() => service.getDrugTypes())
    .then((res) => {
      dispatch({
        type: SET_DRUG_TYPES,
        payload: res.data.data,
      });

      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiSuccess: true,
          message: "Drug type created successfully.",
          operation: "create",
        },
      });
    })
    .catch((error) => {
      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiError: true,
          message: errorMessage(error),
          operation: "create",
        },
      });
    });
};

export const updateDrugTypeApproval = (id, data) => (dispatch) => {
  dispatch({
    type: API_STATUS_MASTER,
    payload: {
      ...initialState.apiStatus,
      loader: true,
      operation: "update",
    },
  });

  service
    .updateDrugTypeApproval(id, data)
    .then(() => service.getDrugTypes())
    .then((res) => {
      dispatch({
        type: SET_DRUG_TYPES,
        payload: res.data.data,
      });

      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiSuccess: true,
          message: "Approval settings updated successfully.",
          operation: "update",
        },
      });
    })
    .catch((error) => {
      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiError: true,
          message: errorMessage(error),
          operation: "update",
        },
      });
    });
};

export const saveAdminApprovalConfig = (data) => (dispatch) => {
  dispatch({
    type: API_STATUS_MASTER,
    payload: {
      ...initialState.apiStatus,
      loader: true,
      operation: "adminSave",
    },
  });

  service
    .saveAdminApprovalConfig(data)
    .then((res) => {
      dispatch({
        type: SET_ADMIN_APPROVAL_CONFIG,
        payload: res.data.data ?? data,
      });

      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiSuccess: true,
          message: res.data.message || "Approval settings saved successfully.",
          operation: "adminSave",
        },
      });
    })
    .catch((error) => {
      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiError: true,
          message: errorMessage(error),
          operation: "adminSave",
        },
      });
    });
};

export const saveDrugTypeApprovalSettings = (payload) => (dispatch) => {
  dispatch({
    type: API_STATUS_MASTER,
    payload: {
      ...initialState.apiStatus,
      loader: true,
      operation: "save",
    },
  });

  service
    .saveDrugTypeApprovalSettings(payload)
    .then(() => service.getDrugTypes())
    .then((res) => {
      dispatch({
        type: SET_DRUG_TYPES,
        payload: res.data.data,
      });

      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiSuccess: true,
          message: "Approval settings saved successfully.",
          operation: "save",
        },
      });
    })
    .catch((error) => {
      dispatch({
        type: API_STATUS_MASTER,
        payload: {
          ...initialState.apiStatus,
          loader: false,
          apiError: true,
          message: errorMessage(error),
          operation: "save",
        },
      });
    });
};
